export interface DataTable {
  data: any[],
  dataFieldDTOList: any[],
  draw: number,
  recordsFiltered: number,
  recordsTotal: number,
  queryTs: number
}

export class DataTableModel implements DataTable {
  data = [];
  dataFieldDTOList = [];
  draw = 0;
  recordsFiltered = 0;
  recordsTotal = 0;
  queryTs = 0;
}
